import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/app/layouts/PageLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkHeader"] */ "/vercel/path0/components/work/WorkHeader/WorkHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkHeaderGrant"] */ "/vercel/path0/components/work/WorkHeader/WorkHeaderGrant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkHeaderProposal"] */ "/vercel/path0/components/work/WorkHeader/WorkHeaderProposal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkTabProvider","useWorkTab"] */ "/vercel/path0/components/work/WorkHeader/WorkTabContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorkRightSidebar"] */ "/vercel/path0/components/work/WorkRightSidebar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
